import React, {useEffect, useRef, useState} from "react";
import "./TradingCupLeaderboard.scss";
import {usePagination, useTable} from "react-table";
import {useDispatch, useSelector} from "react-redux";
import DropdownIcon from "../../assets/icons/dropdown-arrow-gray.svg";
import BlueTickIcon from "../../assets/icons/tick-blue-circle.svg";
import copyIcon from "../../assets/icons/copy-big.svg";
import Card from "../../reusableComponents/Card";
import {formatDateToCustomFormat} from "../../utils/helpers/date";
import {formatUSD} from "../../utils/helpers/string";
import {getPaymentHistory} from "../../store/reducers/accountSlice";
import {toast} from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import ReactTable from "../../components/ReactTable/ReactTable";
import ReactCountryFlag from "react-country-flag";
import {resolveCountryCode, getDisplayCountryName} from "../../utils/helpers/country";

function TradingCupTable({loading, leaderboardData}) {
  const dispatch = useDispatch();

  const idToken = useSelector((state) => state.auth.idToken);
  const paymentValue = useSelector((state) => state.account.paymentHistory);
  const [paymentHistory, setPaymentHistory] = useState(paymentValue);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  useEffect(() => {
    dispatch(getPaymentHistory({idToken, selectedBrand}));
  }, [idToken]);
  useEffect(() => {
    setPaymentHistory(paymentValue);
  }, [paymentValue]);
  const [data, setData] = useState([]);
  const [isCalender, setIsCalender] = useState(false);
  const [date, setDate] = useState(new Date());
  const [isFundingDropdown, setFundingDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [isBalanceDropdown, setBalanceDropdown] = useState(false);
  const balanceRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.classList.contains("column_header")) {
        setFundingDropdown(false);
      }

      if (balanceRef.current && !balanceRef.current.contains(event.target) && !event.target.classList.contains("column_header")) {
        setBalanceDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  const handleCopyToClipboard = (text) => {
    toast("Copied Transaction Id", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };
  const truncateString = (inputString, maxLength) => {
    const formattedString = inputString.toString();
    if (formattedString.length > maxLength) {
      return inputString.toString().substring(0, maxLength) + "...";
    }
    return inputString;
  };

  const fundingBackgroundColors = {
    "Free Plan": "free_background",
    "Aggressive Plan": "aggressive_background",
    "Standard Plan": "standard_background",
    "Swing Plan": "swing_background",
  };

  console.log("leaderboardData", leaderboardData);

  const columns = React.useMemo(
    () => [
      {
        Header: (
          <div
            className="column_header"
            style={{paddingLeft: "16px"}}
          >
            #
          </div>
        ),
        id: "position",
        Cell: ({row}) => (
          <div
            className="column_one_wrapper"
            style={{paddingLeft: "10px"}}
          >
            {row.index + 1}.
          </div>
        ),
        disableSortBy: true,
      },
      {
        Header: (
          <div className="column_header">
            User Name{" "}
            <img
              src={DropdownIcon}
              alt="arrow-down"
            />
          </div>
        ),
        accessor: "user_fullname",
        Cell: ({value}) => <div className="column_one_wrapper">{value || "-"}</div>,
      },
      // {
      //   Header: (
      //     <>
      //       <div className="column_header">
      //         Challenge Name{" "}
      //         <img
      //           src={DropdownIcon}
      //           alt="arrow-down"
      //         />
      //       </div>
      //       {isFundingDropdown && (
      //         <div
      //           className="table_dropdown funding_dropdown"
      //           ref={dropdownRef}
      //         >
      //           <ul>
      //             <li>
      //               All
      //               <img
      //                 src={BlueTickIcon}
      //                 alt="blue tick"
      //               />
      //             </li>
      //             <li>Standard Plan</li>
      //             <li>Aggressive Plan</li>
      //             <li>Swing Plan</li>
      //             <li>Instant Plan</li>
      //           </ul>
      //         </div>
      //       )}
      //     </>
      //   ),
      //   accessor: "challenge_name",
      //   Cell: ({value, row}) => (
      //     <div className="column_one_wrapper">
      //       <div>{value}</div>
      //     </div>
      //   ),
      // },
      {
        Header: <div className="column_header">Latest Equity</div>,
        accessor: "latest_equity",
        Cell: ({value}) => (
          <div className="column_one_wrapper">
            <div>{formatUSD(value) || "-"}</div>
          </div>
        ),
      },

      // {
      //   Header: (
      //     <>
      //       <div className="column_header">
      //         Login Id{" "}
      //         <img
      //           src={DropdownIcon}
      //           alt="arrow-down"
      //         />{" "}
      //       </div>
      //       {isBalanceDropdown && (
      //         <div
      //           className="table_dropdown balance_dropdown"
      //           ref={balanceRef}
      //         >
      //           <ul>
      //             <li>
      //               All
      //               <img
      //                 src={BlueTickIcon}
      //                 alt="blue tick"
      //               />
      //             </li>
      //             <li>25K Challenge</li>
      //             <li>50K Challenge</li>
      //             <li>100K Challenge</li>
      //             <li>200K Challenge</li>
      //           </ul>
      //         </div>
      //       )}
      //     </>
      //   ),
      //   accessor: "login_id",
      //   Cell: ({value}) => (
      //     <div className="column_one_wrapper">
      //       <div>{value ? value : "-"}</div>
      //     </div>
      //   ),
      // },
      // {
      //   Header: (
      //     <div className="column_header">
      //       Transaction Id{" "}
      //       <img
      //         src={DropdownIcon}
      //         alt="arrow-down"
      //       />
      //     </div>
      //   ),
      //   // accessor: "transactionId",
      //   accessor: "id",
      // },
      // {
      //   Header: (
      //     <div className="column_header">
      //       Phase
      //       <img
      //         src={DropdownIcon}
      //         alt="arrow-down"
      //       />
      //     </div>
      //   ),
      //   accessor: "phase",
      //   Cell: ({value}) => (
      //     <>
      //       <div
      //         className="column_one"
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           justifyContent: "center",
      //           gap: "20px",
      //         }}
      //       >
      //         <div> {value}</div>
      //         {/* <CopyToClipboard
      //           onCopy={handleCopyToClipboard}
      //           text={value}
      //         >
      //           <p
      //             className="table_copy_button"
      //             style={{
      //               marginRight: "20px",
      //               cursor: "pointer",
      //             }}
      //           >
      //             <img
      //               src={copyIcon}
      //               alt=""
      //               height={"18px"}
      //               width={"18px"}
      //             />
      //           </p>
      //         </CopyToClipboard> */}
      //       </div>
      //     </>
      //   ),
      // },
      {
        Header: (
          <div className="column_header">
            Profit
            <img
              src={DropdownIcon}
              alt="arrow-down"
            />
          </div>
        ),
        accessor: "profit",
        Cell: ({value}) => (
          <div className="column_one_wrapper">
            <div>{formatUSD(value) || "-"}</div>
          </div>
        ),
      },
      {
        Header: (
          <div className="column_header">
            Gain %
            <img
              src={DropdownIcon}
              alt="arrow-down"
            />
          </div>
        ),
        accessor: "gain",
        Cell: ({value}) => (
          <div className="column_one_wrapper">
            <div>{value ? `${value}` : "-"}</div>
          </div>
        ),
      },

      {
        Header: (
          <div className="column_header">
            Country
            <img
              src={DropdownIcon}
              alt="arrow-down"
            />
          </div>
        ),
        accessor: "country",
        Cell: ({value}) => {
          const countryCode = resolveCountryCode(value);
          const displayName = getDisplayCountryName(value);

          return (
            <div
              className="column_one_wrapper"
              style={{textAlign: "left"}}
            >
              {countryCode ? (
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  title={displayName}
                />
              ) : (
                <div
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                  }}
                />
              )}
              <div>{displayName || "-"} </div>
            </div>
          );
        },
      },

      // {
      //   Header: (
      //     <div className="column_header">
      //       Date{" "}
      //       <img
      //         src={DropdownIcon}
      //         alt="arrow-down"
      //       />
      //     </div>
      //   ),
      //   accessor: "start_date",
      //   Cell: ({value}) => (
      //     <div className="column_one_wrapper">
      //       <div>{formatDateToCustomFormat(value)}</div>
      //     </div>
      //   ),
      // },
    ],
    [isFundingDropdown, isBalanceDropdown],
  );
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Card className="tradingCup_table">
      <div className=" table_wrapper">
        <div className="table_header">
          <div className="select_wrapper"></div>
        </div>
        <div className="table_scroll_wrapper">
          <ReactTable
            loading={loading?.loading}
            data={Array.isArray(leaderboardData) && leaderboardData}
            columns={columns}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </Card>
  );
}

export default TradingCupTable;

function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.41">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7396 3.25C9.96556 3.25 9.32056 3.841 9.25256 4.612C9.1114 6.22294 9.07565 7.84139 9.14556 9.457L8.89256 9.475L7.40256 9.583C7.18496 9.5989 6.97522 9.67103 6.79386 9.79233C6.6125 9.91363 6.46576 10.0799 6.36798 10.275C6.2702 10.47 6.22475 10.6871 6.23607 10.905C6.24739 11.1229 6.3151 11.3341 6.43256 11.518C7.52898 13.2337 8.94176 14.7252 10.5956 15.913L11.1916 16.342C11.4276 16.5116 11.7109 16.6029 12.0016 16.6029C12.2922 16.6029 12.5755 16.5116 12.8116 16.342L13.4076 15.913C15.0614 14.7253 16.4742 13.2337 17.5706 11.518C17.688 11.3341 17.7557 11.1229 17.7671 10.905C17.7784 10.6871 17.7329 10.47 17.6351 10.275C17.5374 10.0799 17.3906 9.91363 17.2093 9.79233C17.0279 9.67103 16.8182 9.5989 16.6006 9.583L15.1106 9.475C15.0262 9.46875 14.9419 9.46275 14.8576 9.457C14.9276 7.842 14.8916 6.223 14.7506 4.612C14.718 4.24011 14.5473 3.89392 14.272 3.64177C13.9967 3.38962 13.6369 3.24983 13.2636 3.25H10.7396ZM10.6836 10.115C10.5697 8.32763 10.5907 6.53421 10.7466 4.75H13.2566C13.4128 6.53418 13.4342 8.3276 13.3206 10.115C13.3144 10.2141 13.3279 10.3134 13.3603 10.4073C13.3928 10.5011 13.4436 10.5875 13.5097 10.6616C13.5759 10.7356 13.6561 10.7958 13.7456 10.8386C13.8352 10.8814 13.9324 10.906 14.0316 10.911C14.3556 10.927 14.6786 10.947 15.0016 10.971L16.0826 11.05C15.1224 12.464 13.9207 13.6979 12.5326 14.695L12.0026 15.076L11.4706 14.695C10.0824 13.6979 8.88069 12.464 7.92056 11.05L9.00156 10.97C9.32456 10.947 9.64856 10.927 9.97156 10.911C10.0708 10.9062 10.1681 10.8816 10.2578 10.8389C10.3475 10.7961 10.4278 10.736 10.494 10.6619C10.5603 10.5878 10.6111 10.5014 10.6437 10.4075C10.6762 10.3136 10.6898 10.2142 10.6836 10.115Z"
          fill="#fff"
        />
        <path
          d="M5.75 17C5.75 16.8011 5.67098 16.6103 5.53033 16.4697C5.38968 16.329 5.19891 16.25 5 16.25C4.80109 16.25 4.61032 16.329 4.46967 16.4697C4.32902 16.6103 4.25 16.8011 4.25 17V19C4.25 19.966 5.034 20.75 6 20.75H18C18.4641 20.75 18.9092 20.5656 19.2374 20.2374C19.5656 19.9092 19.75 19.4641 19.75 19V17C19.75 16.8011 19.671 16.6103 19.5303 16.4697C19.3897 16.329 19.1989 16.25 19 16.25C18.8011 16.25 18.6103 16.329 18.4697 16.4697C18.329 16.6103 18.25 16.8011 18.25 17V19C18.25 19.0663 18.2237 19.1299 18.1768 19.1768C18.1299 19.2237 18.0663 19.25 18 19.25H6C5.9337 19.25 5.87011 19.2237 5.82322 19.1768C5.77634 19.1299 5.75 19.0663 5.75 19V17Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
